import { render, staticRenderFns } from "./coupon-picker.vue?vue&type=template&id=50c37aa4&scoped=true&lang=pug"
import script from "./coupon-picker.vue?vue&type=script&lang=ts"
export * from "./coupon-picker.vue?vue&type=script&lang=ts"
import style0 from "./coupon-picker.vue?vue&type=style&index=0&id=50c37aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c37aa4",
  null
  
)

export default component.exports